// extracted by mini-css-extract-plugin
export default {"tabLine":"TabsPaymentOrderKinds_tabLine__MnZwA","space":"TabsPaymentOrderKinds_space__D58Xy","placeHolderShimmer":"TabsPaymentOrderKinds_placeHolderShimmer__FkPks"};